import React from 'react'
import { Navigate } from 'react-router-dom'

import { useModuleConfig } from 'hooks/useModuleConfig/useModuleConfig'
import routePath from 'router/routePath'

type DefectNoticeGateProps = {
  redirectTo?: string
  children: React.ReactElement
}

export const DefectNoticeGate: React.FC<DefectNoticeGateProps> = ({
  children,
  redirectTo = routePath.notFound404,
}) => {
  const { contractTerminationOnly, defectNotice } = useModuleConfig()
  const enabled = !contractTerminationOnly && defectNotice.enabled === true

  return enabled ? children : <Navigate to={redirectTo} replace />
}
